// extracted by mini-css-extract-plugin
export default {"generic":"modal_generic__bLKF1"};